import Typography from '@mui/material/Typography';
import React from 'react';

import { EmailBasicDto, EmailThreadSummaryItemDto } from '@/api/generated';
import { themeColors } from '@/config/theme/themeColors.ts';
import { TextCutWithDotsStyles } from '@/styles/text.styles.ts';

interface Props {
  email: EmailBasicDto | EmailThreadSummaryItemDto;
}

export const EmailSummaryBodyPreview: React.FC<Props> = props => {
  const { email } = props;

  return (
    <Typography component="div" sx={TypographySx} variant="f12Regular">
      {email.bodyPreview}
    </Typography>
  );
};

const TypographySx = {
  ...TextCutWithDotsStyles,
  color: themeColors.greyDark,
};
